import { Section } from './section'
import { BodyText, BulletList, Subheading, Subsection } from './styles'

export const Organisation = () => {
  return (
    <Section title="Organisation">
      <BodyText>The details of the company taking on this tenancy.</BodyText>

      <Subsection>
        <Subheading>What you will need</Subheading>
        <BulletList>
          <li>The company's full legal name</li>
          <li>Company number</li>
          <li>Company address</li>
          <li>The date the company was incorporated</li>
        </BulletList>
      </Subsection>
    </Section>
  )
}
